import React from "react";
import {Pane} from "evergreen-ui";
import PeriodsValuesPage from "./PeriodsValuesPage";

export default function ConstructorPeriodsValues() {
    return (
        <Pane margin={40}>
            <PeriodsValuesPage
                isEdit={false}
            />
        </Pane>
    )
}